import React from "react";
import { Megaphone } from "lucide-react";

/** Single togglable announcement banner shown under the Hero section. */
export default function AnnouncementEditor({ data, onChange }) {
  const val = data || { active: false, text: "" };
  return (
    <div className="rounded-2xl bg-apex-card border border-apex-line p-5" data-testid="section-announcement">
      <div className="text-xs uppercase tracking-[0.3em] text-apex-gold/80 mb-1 flex items-center gap-2">
        <Megaphone className="w-3.5 h-3.5" /> Banner s oznámením
      </div>
      <p className="text-xs text-apex-cream/60 mb-4">
        Animovaný pruh zobrazený hned pod úvodní sekcí (např. sleva, zavřeno o svátcích).
      </p>
      <label className="inline-flex items-center gap-2 text-sm text-apex-cream mb-3">
        <input
          type="checkbox"
          checked={!!val.active}
          onChange={(e) => onChange({ ...val, active: e.target.checked })}
          data-testid="announcement-active-toggle"
        />
        Zobrazit banner na webu
      </label>
      <label className="block">
        <div className="text-xs text-apex-cream/70 mb-1">Text banneru</div>
        <textarea
          value={val.text || ""}
          rows={2}
          onChange={(e) => onChange({ ...val, text: e.target.value })}
          className="w-full px-3 py-2 rounded-lg bg-apex-bg border border-apex-line text-apex-cream text-sm resize-y focus:outline-none focus:border-apex-gold/60"
          data-testid="announcement-text-input"
        />
      </label>
    </div>
  );
}
